const Types = {
  GIFTCARDS__GET_GIFTCARDS: 'GIFTCARDS__GET_GIFTCARDS',
  GIFTCARDS__MANAGE_GIFTCARDS: 'GIFTCARDS__MANAGE_GIFTCARDS',
};

export default Types;
